import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Overview', href: '#overview' },
    { label: 'Labs', href: '#highlighted-labs' },
    { label: 'Resources', href: '#practice-resources' },
    { label: 'Interactive', href: '#interactive-labs' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0A1628]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/09b42268e64b75a1bdbfb319cdd0d3b1/944ced67edcaa1780fffee96bcaa68e9.png"
            alt="CyberSkill Hub Logo"
            className="h-9 w-auto object-contain"
          />
          <span className="text-white font-bold text-lg tracking-tight hidden sm:block">
            Cyber<span className="text-[#00D9FF]">Skill</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className="text-gray-300 hover:text-[#00D9FF] text-sm font-medium transition-colors duration-200 cursor-pointer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="#highlighted-labs"
            className="px-5 py-2 rounded-full bg-[#00D9FF] text-[#0A1628] text-sm font-semibold hover:bg-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Start Free Labs
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0A1628]/98 backdrop-blur-md border-t border-white/10 px-6 py-4">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className="text-gray-300 hover:text-[#00D9FF] text-sm font-medium transition-colors duration-200 cursor-pointer block"
                  onClick={() => setMenuOpen(false)}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#highlighted-labs"
                className="block text-center px-5 py-2 rounded-full bg-[#00D9FF] text-[#0A1628] text-sm font-semibold cursor-pointer whitespace-nowrap"
                onClick={() => setMenuOpen(false)}
              >
                Start Free Labs
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
